import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import { useRestricedViewNotice } from "lib/hooks/useRestrictedRowClick";
import { EventNames, useTracking } from "lib/tracking";
import { AiNoticeSource } from "../types";

type Props = {
  source: AiNoticeSource;
};

export default function NoticeSource({ source }: Props) {
  const { logEvent } = useTracking();
  const { viewRecord: showNotice } = useRestricedViewNotice("Source click");

  const handleSourceClick = (source: AiNoticeSource) => {
    showNotice(source.id);
    logEvent(EventNames.citationOpened, {
      "Action type": "Notice source clicked",
      "Criteria name": "Ai assistant",
    });
  };

  return (
    <Flex column gap={8}>
      <Text bold>{source.title}</Text>
      {/* TODO: Add snippet */}
      <MentionsText onClick={() => handleSourceClick(source)}>View source</MentionsText>
    </Flex>
  );
}

const MentionsText = styled(Text)(({ theme }) => ({
  color: theme.colors.sysPrimaryDefault,
  cursor: "pointer",
}));
